__turbopack_context__.v({
  "CardsContainer": "Cards-module__dpJ8Dq__CardsContainer",
  "CardsContentF": "Cards-module__dpJ8Dq__CardsContentF",
  "CategorySections": "Cards-module__dpJ8Dq__CategorySections",
  "dateSections": "Cards-module__dpJ8Dq__dateSections",
  "textContainer": "Cards-module__dpJ8Dq__textContainer",
  "title": "Cards-module__dpJ8Dq__title",
  "titleContainer": "Cards-module__dpJ8Dq__titleContainer",
});
